export default __webpack_public_path__ + "images/product/skin_types/normal-97c0dedf1ca2aa3ec7b2cfc768ff5454.svg";